import axios, { setAuthToken } from "common/configs/axiosConfigs";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { auth, provider } from "./components/googleAuth";
import { signInWithPopup } from "firebase/auth";
import googleGLogo from "assets/img/Google_G_logo.png";
import logo from "assets/img/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const { auth: user } = useSelector((state) => state.auth);
  const [values, setValues] = useState({});
  const [googleAuth, setGoogleAuth] = useState(null);
  const handleGoogleAuth = () => {
    signInWithPopup(auth, provider).then((data) => {
      const {
        user: { uid, phoneNumber, photoURL },
        _tokenResponse: { fullName, email },
      } = data;

      setGoogleAuth({ name: fullName, email, phone: phoneNumber, udid: uid, profile: photoURL });
    });
  };
  const handleSubmit = async (e) => {
    e?.preventDefault();
    try {
      const { data } = await axios.post("", {
        action: "login",
        accountType: googleAuth ? 2 : 1,
        ...values,
        ...googleAuth,
      });
      if (data.success) {
        localStorage.setItem("user-auth", JSON.stringify(data.data));
        toast.success("You logged in successfully!");
        navigate("/");
        setAuthToken(data?.data?.token);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  const handleInput = ({ target: { value, name } }) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    if (user) {
      setValues({ email: user.email, password: user.password });
      handleSubmit();
    }
  }, []);
  useEffect(() => {
    googleAuth && handleSubmit();
  }, [googleAuth]);
  return (
    <section className="login-section p-0">
      <div className="container">
        <img src={logo} alt="logo" style={{ width: 70, display: "block", margin: "0 auto 20px" }} />
        <div className="card login-box mx-auto">
          <h3 className="text-center">Welcome back!</h3>
          <p className="text-muted text-center">Enter your details to access admin panel</p>
          <form onSubmit={handleSubmit}>
            <label className="mb-3">
              {/* <span>Email</span> */}
              <input
                type="email"
                name="email"
                onChange={handleInput}
                className="form-control"
                placeholder="Enter your email"
                required
              />
            </label>
            <label className="mb-3">
              {/* <span>Password</span> */}
              <input
                name="password"
                onChange={handleInput}
                type="password"
                className="form-control"
                placeholder="Enter password"
                required
              />
            </label>
            <button type="submit" className="btn btn-primary w-100">
              Sign In
            </button>
          </form>
          <div className="divider-text">
            <span>Or sign in with</span>
          </div>
          <button type="button" onClick={handleGoogleAuth} className="btn btn-google">
            <img src={googleGLogo} alt="google" />
            Sign in with Google
          </button>
          <p className="my-3 text-center">
            Don't have an account?{" "}
            <Link to="/register" className="text-primary text-decoration-underline">
              Register now
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Login;
